<div class="modal-header">
    <h3 class="modal-title" id="modal-title" translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body">
    @if (requestError) {
        <div
            class="bg-danger text-white p-2 mb-3"
            translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_GET_ERROR_BODY"
        ></div>
    }
    @if (assignedTask) {
        <div
            class="bg-success text-black p-2 mb-3"
            translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_SUCCESS_MESSAGE"
        ></div>
        <lib-pace-notification-preview
            [notification]="convertToPreview(assignedTask)"
            [notificationType]="getTypeLabel(assignedTask)"
            [extraLinks]="[successBackLink]"
        ></lib-pace-notification-preview>
    } @else if (isRequesting) {
        <progressbar [striped]="true" [value]="100" type="default">
            <span translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_REQUESTING"></span>
        </progressbar>
    } @else if (isLoading) {
        <progressbar [striped]="true" [value]="100" type="default">
            <span translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_LOADING"></span>
        </progressbar>
    } @else {
        <tabset type="pills" paceCoreTabsRole>
            <tab [heading]="description">
                <pace-other-task-list
                    [tasks]="equipmentNotifications"
                    [isLoading]="isLoading"
                    (getTask)="getTask($event)"
                ></pace-other-task-list>
            </tab>
            <tab
                [heading]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_CUSTOMER_HEADING' | translate"
                [disabled]="!hasCustomerId"
            >
                <pace-other-task-list
                    [tasks]="customerNotifications"
                    [isLoading]="isLoading"
                    [isCustomerTab]="true"
                    (getTask)="getTask($event)"
                ></pace-other-task-list>
            </tab>
        </tabset>
    }
</div>
